// extracted by mini-css-extract-plugin
module.exports = {"countdownCard":"countdownTimer_countdownCard__1YQ0j","countdownAvatar":"countdownTimer_countdownAvatar__3QIj-","countdownText":"countdownTimer_countdownText__10Ulk"};